import React from "react";
import styled from "styled-components";

function SmallTitle({ icon, image, title }) {
  return (
    <SmallTitleStyled>
      {icon && <p>{icon}</p>}
      {image && <img src={image} alt={title} />}
      <h3>{title}</h3>
    </SmallTitleStyled>
  );
}

const SmallTitleStyled = styled.div`
  display: flex;
  align-items: center;
  p {
    padding-right: 1rem;
    svg {
      font-size: 3rem;
    }
  }
  h3 {
    color: var(--white-color);
    font-size: 2rem;
  }
  img {
    padding-right: 1rem;
    margin-left: 1rem;
    width: 52.8px;
    height: 52.8px;
    object-fit:contain;
    
  }
`;

export default SmallTitle;
